<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card [options]="options" (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
                Raporlar <a class="btn btn-primary"  routerLink="/newreport">+ Yeni Ekle</a>
              </ng-container>
              <ng-container mCardBody>
                <div class="row mb-2">
           
                </div>
               
                <table class="table table-bordered">
                  <thead>
                  <tr>
                   
                    <th>Adı</th>
                    <th>Tarih</th>
                    <th>Sorumlu</th>
                  
                    <th>İşlemler</th>
                  </tr>
                </thead>
                  <tr *ngFor="let h of filteredhammeddeler">
                   
                    <td>{{h.name}}</td>
                    <td>{{h.lastUpdate |date:'dd.MM.yyyy'}}</td>
                    <td>{{h.authorizedPersonel}}</td>
                 
                    <td>
                     <a [routerLink]="['/editreport', h.id]">
                       <i class="la la-edit success"  style="cursor: pointer;" title="Düzenle"></i></a> |
                   <i class="la la-copy success"  style="cursor: pointer;" (click)="copy(h.id)" title="Kopyala"></i>|
                      <i class="la la-remove danger" (click)="delete(h.id)" style="cursor: pointer;" title="Sil"></i>|
                      <i class="la la-download primary" (click)="download(h.id)" style="cursor: pointer;" title="İndir"></i>
                    </td>
                  </tr>
                
                </table>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
